import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { Button, Paper } from '@mui/material';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { FocusError } from 'focus-formik-error';
import { useDispatch, useSelector } from 'react-redux';
import { BeatLoader } from 'react-spinners';
// import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { toast } from 'react-toastify';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { getCustomerDocumentFields, getCustomerRegData } from '../../../Redux/action/Admin/CustomerAction';

import { adminMainUrl } from "../../../Config.jsx";

const Documentation = ({ customer_id }) => {
  let [disable, setDisable] = useState(false);
  let [showLoader, setShowLoader] = useState(true);
  const [fileNames, setFileNames] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    console.log(customer_id)
    dispatch(getCustomerDocumentFields(customer_id))
    if (customer_id) {
      dispatch(getCustomerRegData(customer_id))
    }
  }, []);

  let {
    loadingCustomerDocumentFieldsApi,
    CustomerDocumentFieldsError,
    CustomerDocumentFields,

    loadingCustomerRegDataApi,
    CustomerRegDataError,
    CustomerRegData,
  } = useSelector(state => state?.CustomerReducer);

  console.log('fields', CustomerDocumentFields?.data)

  const validDocumentFields = Array.isArray(CustomerDocumentFields?.data) ? CustomerDocumentFields?.data : [];


  const formik = useFormik({
    initialValues: validDocumentFields?.reduce((values, field) => {
      values[field.name] = null; // Initialize as null for file upload
      return values;
    }, {}),
    validationSchema: Yup.object(),
    onSubmit: (values, { resetForm }) => {

    },
  });

  // Handle file selection and generate image preview
  const handleFileChange = (event, fieldName) => {
    const file = event.target.files[0]; // Get the first file only
    formik.setFieldValue(fieldName, file);

    // Generate preview and store file name
    if (file) {
      const filePreview = URL.createObjectURL(file);

      setFileNames((prev) => ({
        ...prev,
        [fieldName]: file.name, // Store the file name
      }));
    } else {
      // Clear preview and file name if no file is selected

      setFileNames((prev) => ({
        ...prev,
        [fieldName]: null,
      }));
    }
  };


  // Set form values and file previews if data is coming from CustomerRegData
  useEffect(() => {
    if (CustomerRegData && CustomerRegData?.CustomerDocuments) {
      const initialValues = {};
      const filePreviewNames = {};

      CustomerRegData?.CustomerDocuments?.forEach(doc => {
        initialValues[doc.documentName] = doc.image; // Set image path for existing documents
        filePreviewNames[doc.documentName] = doc.image.split('/').pop(); // Extract file name from path
      });

      formik.setValues(initialValues);
      setFileNames(filePreviewNames); // Set file preview names
    }
  }, [CustomerRegData]);


  return (
    <>
      {/* <Toaster /> */}
      {

        <div id="section2" className="section2 w-100 customer_main_detail_form" >

          <form onSubmit={formik.handleSubmit} className='p-4'>
            <div className='form-heading-bg'>
              <span>Documentation</span>

            </div>
            {validDocumentFields?.length > 0 ?
              <div className="row">
                {validDocumentFields?.map((field) => (
                  <div key={field.id} className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">{field.name}{field.mandatory && <span className='text-danger'>*</span>}</label>
                      <div className="custom-file-container">
                        <label className="custom-file-container__custom-file">
                          <i className="fa-solid fa-upload"></i> Upload Files
                          <input
                            type="file"
                            className="custom-file-container__custom-file__custom-file-input d-none"
                            accept={JSON.parse(field.doucumentFormat).join(",")}
                            onChange={(event) => handleFileChange(event, field.name)}
                          />
                          <span className="custom-file-container__custom-file__custom-file-control"></span>
                        </label>

                      </div>
                    </div>
                    {formik.touched[field.name] && formik.errors[field.name] ? (
                      <div className="text-danger small">{formik.errors[field.name]}</div>
                    ) : null}
                    {fileNames[field.name] && (
                      <p className="selected-file-text">Selected file: {fileNames[field.name]}</p>
                    )}
                  </div>
                ))}
              </div>
              :
              <div className='text-center'>No documents found</div>}


          </form>
        </div >

      }
    </>

  )
}

export default Documentation